import { render } from "./AgregarAdministradorEvento.vue?vue&type=template&id=1452ae8e&scoped=true"
import script from "./AgregarAdministradorEvento.vue?vue&type=script&lang=js"
export * from "./AgregarAdministradorEvento.vue?vue&type=script&lang=js"

import "./AgregarAdministradorEvento.vue?vue&type=style&index=0&id=1452ae8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1452ae8e"]])

export default __exports__